module.exports = __webpack_public_path__ + "img/1524693338.0119d898.jpg";